/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MapResult } from "./MapResult";
import {
  MapResultFromJSON,
  MapResultFromJSONTyped,
  MapResultToJSON,
  MapResultToJSONTyped,
} from "./MapResult";

/**
 *
 * @export
 * @interface Theme
 */
export interface Theme {
  /**
   *
   * @type {string}
   * @memberof Theme
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Theme
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof Theme
   */
  description?: string;
  /**
   *
   * @type {Array<MapResult>}
   * @memberof Theme
   */
  maps?: Array<MapResult>;
}

/**
 * Check if a given object implements the Theme interface.
 */
export function instanceOfTheme(value: object): value is Theme {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function ThemeFromJSON(json: any): Theme {
  return ThemeFromJSONTyped(json, false);
}

export function ThemeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Theme {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"] == null ? undefined : json["name"],
    description: json["description"] == null ? undefined : json["description"],
    maps: json["maps"] == null ? undefined : (json["maps"] as Array<any>).map(MapResultFromJSON),
  };
}

export function ThemeToJSON(json: any): Theme {
  return ThemeToJSONTyped(json, false);
}

export function ThemeToJSONTyped(value?: Theme | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    description: value["description"],
    maps: value["maps"] == null ? undefined : (value["maps"] as Array<any>).map(MapResultToJSON),
  };
}
